import styled from 'styled-components';
import { PlayerEnum } from '../../Player/constants';
import { getPlayerColor } from '../../../utils/playerColor';
import { changeSelectedPlayer } from '../../Game/Game';

const StyledSelectedPlayer = styled.div<{
  $number: PlayerEnum;
  $selectedPlayer: Boolean;
  $isPlayerSelected: Boolean;
}>`
  color: ${(props) => getPlayerColor(props.$number)};
  font-size: 2em;
  text-shadow:
    -3px 0 black,
    0 -3px black,
    0 3px black,
    3px 0 black;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  -o-user-select: none;
  user-select: none;
  margin: 3px 0px 0px 3px;
  border: solid
    ${(props) => {
      if (props.$selectedPlayer) return 'red';
      else if (props.$isPlayerSelected) return 'gray';
      else return 'transparent';
    }}
    2px;
`;

const StyledPlayerSelector = styled.div`
  display: flex;
  flex-direction: column;
  text-align: left;
  max-width: 200px;
`;

interface IPlayerSelector {
  playerSelection: {
    isPlayerSelected: boolean[];
    selectedPlayer: number | null;
  };
}

const PlayerSelector = (props: IPlayerSelector) => {
  const handleChange = (n: number) => {
    changeSelectedPlayer(n);
  };

  return (
    <StyledPlayerSelector>
      {[0, 1, 2, 3].map((n) => (
        <StyledSelectedPlayer
          key={n + '_player'}
          $number={n}
          onClick={(e) => handleChange(n)}
          $selectedPlayer={n === props.playerSelection.selectedPlayer}
          $isPlayerSelected={props.playerSelection.isPlayerSelected[n] === true}
        >
          ♟︎
        </StyledSelectedPlayer>
      ))}
    </StyledPlayerSelector>
  );
};

export default PlayerSelector;
